module.exports = __webpack_public_path__ + "images/feature/20190528-ae1b75d85ff9b7033c82d268758786d1.png";